import { useAppUser } from 'components/_hooks'
import { KlLink } from 'components/_shared/KlLink/KlLink'
import React, { ReactNode, useEffect } from 'react'

import { getIsAdmin, getIsPlayer } from 'store/types/user-types'
import { cn } from 'utils'
import { loadUnreadBlogsCount } from 'store/logic/blogs-logic'
import { useDispatch, useSelector } from 'react-redux'
import { getUnreadNewsCount } from 'store/selectors/blog-selectors'

import styles from './LeftMenu.module.scss'
import { DashboardIcon } from 'components/_svg'

interface MenuItemProps {
  children?: ReactNode
  text: string
  url: string
  icon?: string
  count?: number
  className?: string
}

const MenuItem = ({ text, url, icon, children, count, className }: MenuItemProps) => {
  const isActive = window.location.href.toLowerCase().includes(url)  
  return (
    <li className={cn(isActive && styles.active, styles.leftMenuLink)}>
      <KlLink to={url} className={className}>
        {icon && <i className={icon} />}
        {children}
        <span>{text}</span>
        {count > 0 && <b>{count}</b>}
      </KlLink>
    </li>
  )
}

const LeftMenu = () => {
  const dispatch = useDispatch()
  const user = useAppUser()
  const isPlayer = getIsPlayer(user?.Role)
  const isAdmin = getIsAdmin(user?.Role)

  const unreadBlogsCount = useSelector(getUnreadNewsCount)

  useEffect(() => {
      user && dispatch(loadUnreadBlogsCount())
  }, [dispatch,user])

  return (
    <div className="col-auto p-0">
      <div className={styles.lftMenu}>
        <div className={styles.lftMenuScroll}>
          <nav className={styles.leftMenu}>
            <ul>
              <MenuItem url="/tournaments" icon={cn(styles.iconNav, styles.iconNavTournaments)} text="Tournaments" />
              <MenuItem url="/news" icon={cn(styles.iconNav, styles.iconNavNews)} text="News" count={unreadBlogsCount} />
              <MenuItem url="/victory-road-map" icon={cn(styles.iconNav, styles.iconNavResults)} text="Victory" />
              {isPlayer && (
                <MenuItem url="/my-tickets" text="Tickets" icon={cn(styles.iconNav, styles.iconNavTickets)} />
              )}
              {isAdmin && (
                <MenuItem url="/admin/dashboard" text="Admin Dashboard" icon="" className={styles.svgIconNav}>
                  <DashboardIcon className={styles.adminDashboardIcon} />
                </MenuItem>
              )}
            </ul>
          </nav>
        </div>
      </div>
    </div>
  )
}

export default LeftMenu
